var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9877 28.9633C81.3091 25.2847 76.9419 22.3667 72.1356 20.3758C67.3292 18.385 62.1778 17.3603 56.9755 17.3603C51.7731 17.3603 46.6217 18.385 41.8154 20.3758C37.009 22.3667 32.6418 25.2847 28.9632 28.9633L56.9755 56.9756L84.9877 28.9633Z",
    fill: "#7D4ED8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9877 84.9878C92.417 77.5585 96.5908 67.4822 96.5908 56.9756C96.5908 46.469 92.417 36.3927 84.9877 28.9633L56.9755 56.9756L84.9877 84.9878Z",
    fill: "#F38923"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9632 84.9878C36.3925 92.4171 46.4688 96.5909 56.9755 96.5909C67.4821 96.5909 77.5584 92.4171 84.9877 84.9878L56.9755 56.9756L28.9632 84.9878Z",
    fill: "#1FB6C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9632 28.9633C21.5339 36.3927 17.3602 46.469 17.3602 56.9756C17.3602 67.4822 21.5339 77.5585 28.9632 84.9878L56.9755 56.9756L28.9632 28.9633Z",
    fill: "#EF3C6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 29,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.ca9cfc9c45806c2eae9f06841793144a.svg";
export { ForwardRef as ReactComponent };